import React, { Component, Fragment } from 'react';
import PropTypes from 'prop-types';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import _isEmpty from 'lodash/isEmpty';
import initialState from '../helpers/form-helpers/initial-state';
import * as userAccountActions from '../../../store/actions/user-account-actions';
import * as formStateHelpers from '../helpers/form-helpers/form-state-helper';
import { isEmpty } from '../../utils/obj-utils';
import FormSpinner from '../../common/utility/FormSpinner';
import { formMessageConstants } from '../../utils/constants/form-message-constants';
import './user-tickets.scss';
import TicketGroups from './TicketGroups';
import ConfirmationModal from '../../common/utility/ConfirmationModal';
import FormMessage from '../../common/utility/FormMessage';
import TicketModalBody from './TicketModalBody';
import { formConstants } from '../../utils/constants/form-constants';
import { isNullOrUndefined } from '../../../../../general/js/general-helpers';
import withLoadingInterval from '../../hocComponents';

class UserTickets extends Component {
    constructor(props) {
        super(props);

        this.state = initialState.userTicketsFormState;
        this.loadUserTicketsData = this.loadUserTicketsData.bind(this);
        this.reloadUserTicketsData = this.reloadUserTicketsData.bind(this);
        this.displayUserTicketsForm = this.displayUserTicketsForm.bind(this);
        this.displayAvailableTicketsData = this.displayAvailableTicketsData.bind(this);
        this.displayConfirmationModal = this.displayConfirmationModal.bind(this);
        this.handleHideOldTicketsChange = this.handleHideOldTicketsChange.bind(this);
        this.handleSaveAndContinue = this.handleSaveAndContinue.bind(this);
        this.handlePrintTicketClick = this.handlePrintTicketClick.bind(this);
        this.toggleConfirmationModal = this.toggleConfirmationModal.bind(this);
        this.loadUserTicketsData();
    }

    componentDidUpdate(prevProps) {
        if (
            prevProps.hideOldTickets !== this.props.hideOldTickets
        ) {
            this.reloadUserTicketsData();
        }
    }

    displayUserTicketsForm() {
        const {
            isPdfFileDownloadedSuccessful,
            downloadPdfFileErrorMessages,
            hideOldTickets,
        } = this.props;

        return <Fragment>
            <div className='display-files'>
                <FormMessage
                    isSuccessMessage={isPdfFileDownloadedSuccessful}
                    messages={downloadPdfFileErrorMessages}></FormMessage>
                <p>{formMessageConstants.display}:</p>
                <label className='form-switch'>
                    <input
                        checked={hideOldTickets}
                        onChange={this.handleHideOldTicketsChange}
                        type='checkbox' />
                    <i></i>{formMessageConstants.hideOldTickets}
                </label>
            </div>
            {this.displayAvailableTicketsData()}
            {this.displayConfirmationModal()}
        </Fragment>;
    }

    displayAvailableTicketsData() {
        const {
            formData,
            loading,
            isUserTicketsDataLoadedSuccessful,
            userTicketsData,
            upcomingTicket,
            elapsedTime
        } = this.props;
        const { noTicketsFoundText } = formData;
        const shouldDisplayAvailableTickets = isUserTicketsDataLoadedSuccessful && !isEmpty(userTicketsData);
        const shouldDisplayNoTicketsFound = !loading &&
            !isUserTicketsDataLoadedSuccessful &&
            isEmpty(userTicketsData);

        const elapsedTimeLimit = formData[formConstants.elapsedTimeLimit];
        return <div className='category user-tickets'>
            {shouldDisplayAvailableTickets &&
                userTicketsData.map((userTicket, index) => {
                    const { ticketGroups } = userTicket;
                    return <TicketGroups
                        key={index}
                        formData={formData}
                        ticketGroups={ticketGroups}
                        scrollTo={upcomingTicket}
                        onSaveAndContinueClick={this.handleSaveAndContinue}></TicketGroups>;
                })}
            {shouldDisplayNoTicketsFound && <div className='no-files'>
                <p className='info'>{noTicketsFoundText}</p>
            </div>}
            {elapsedTime > elapsedTimeLimit && this.displayLoadingError()}
        </div>;
    }

    displayConfirmationModal() {
        const { formData } = this.props;
        const { printTicketModalText, printTicketInputText } = formData;
        const { isTicketPrintModalOpen, printOptions } = this.state;
        return <ConfirmationModal
            isOpen={isTicketPrintModalOpen}
            inputText={printTicketInputText}
            onModalClose={this.toggleConfirmationModal}
            onApproveClick={this.handlePrintTicketClick}
            isApproveDanger={false}
            isApproveButtonDisabled={false}
            onCancelClick={this.toggleConfirmationModal}
            isCancelButtonDisabled={false}>
            {!_isEmpty(printOptions) && <TicketModalBody
                printTicketModalText={printTicketModalText}
                ticketForPrint={printOptions.ticketForPrint}
                ticketType={printOptions.ticketForPrint.ticketType}
                ticketId={printOptions.ticketForPrint.ticketId}
                firstName={printOptions.firstName}
                firstNameValue={printOptions.firstNameValue}
                lastName={printOptions.lastName}
                lastNameValue={printOptions.lastNameValue}>
            </TicketModalBody>}
        </ConfirmationModal>;
    }

    displayLoadingError() {
        const { formData } = this.props;
        const errorMessage = formData[formConstants.loadingErrorMessage];
        if (!errorMessage) {
            return null;
        }
        return <FormMessage
            isSuccessMessage={false}
            messages={[errorMessage]}
        />;
    }

    handleSaveAndContinue(printOptions) {
        const { firstNameValue, lastNameValue } = this.props.formData;
        this.setState((prevState) => {
            return {
                ...prevState,
                isTicketPrintModalOpen: true,
                printOptions: {
                    ticketForPrint: printOptions.ticketForPrint,
                    firstNameValue: printOptions.firstNameValue || firstNameValue,
                    lastNameValue: printOptions.lastNameValue || lastNameValue
                }
            };
        });
    }

    handlePrintTicketClick(event) {
        event.preventDefault();
        const { actions, formData } = this.props;
        const { printOptions } = this.state;
        this.setState(formStateHelpers.toggleKey('isTicketPrintModalOpen'),
            () => {
                actions.downloadTicketPdf(formData.downloadTicketPdfCallbackUrl, printOptions, formData[formConstants.ssoDomain]);
            });
    }

    toggleConfirmationModal() {
        this.setState(formStateHelpers.toggleKey('isTicketPrintModalOpen'));
    }

    handleHideOldTicketsChange() {
        this.props.actions.toggleHideOldTickets();
    }

    reloadUserTicketsData() {
        const { actions, formData, hideOldTickets } = this.props;
        actions.getUserTickets(formData.getTicketsCallbackUrl, hideOldTickets,
            formData[formConstants.ssoDomain]);
    }

    loadUserTicketsData() {
        const {
            actions, formData, userTicketsData, hideOldTickets
        } = this.props;

        if (!isEmpty(userTicketsData)) {
            return;
        }

        actions.getUserTickets(formData.getTicketsCallbackUrl, hideOldTickets,
            formData[formConstants.ssoDomain]);
    }

    render() {
        const {
            loading,
            formData
        } = this.props;
        const { formTitle } = formData;

        return <Fragment>
            {loading ? <FormSpinner >/</FormSpinner> : null}
            <h1>{formTitle}</h1>
            {this.displayUserTicketsForm()}
        </Fragment>;
    }
}

UserTickets.propTypes = {
    loading: PropTypes.bool.isRequired,
    formData: PropTypes.object.isRequired,
    upcomingTicket: PropTypes.object.isRequired,
};

function mapStateToProps(state) {
    return {
        loading: state.apiStatus.apiCallsInProgress > 0,
        hideOldTickets: isNullOrUndefined(state.userAccount.hideOldTickets) ? initialState.userTicketsFormState.hideOldTickets : state.userAccount.hideOldTickets,
        userTicketsData: state.userAccount.userTicketsData,
        isUserTicketsDataLoadedSuccessful: state.userAccount.isUserTicketsDataLoadedSuccessful,
        isPdfFileDownloadedSuccessful: state.userAccount.isPdfFileDownloadedSuccessful,
        downloadPdfFileErrorMessages: state.userAccount.downloadPdfFileErrorMessages
    };
}

function mapDispatchToProps(dispatch) {
    return {
        actions: {
            getUserTickets: bindActionCreators(userAccountActions.getUserTickets, dispatch),
            downloadTicketPdf: bindActionCreators(userAccountActions.downloadTicketPdf, dispatch),
            toggleHideOldTickets: bindActionCreators(userAccountActions.toggleHideOldTickets, dispatch)
        }
    };
}

export default connect(mapStateToProps, mapDispatchToProps)(withLoadingInterval(UserTickets));
